/**
 * Soks & Joks - Bundle Builder
 *
 * Fully client-side bundle builder:
 * 1. Reads ?boks=boks-2 from URL
 * 2. Loads BOKS config, socks, and jocks from embedded JSON
 * 3. Renders the slot grid and product selectors
 * 4. Manages add/remove and cart submission
 */

(function () {
  'use strict';

  // ---- Read URL param ----
  const urlParams = new URLSearchParams(window.location.search);
  const boksHandle = urlParams.get('boks');

  // ---- Load JSON data ----
  const allBoks = JSON.parse(document.getElementById('boksConfig').textContent);
  const allSoks = JSON.parse(document.getElementById('soksData').textContent);
  const allJoks = JSON.parse(document.getElementById('joksData').textContent);

  // ---- DOM refs ----
  const builder = document.getElementById('bundleBuilder');
  const layout = builder.querySelector('.bundle-builder__layout');
  const noBoksMsg = document.getElementById('noBoksMessage');
  const slotsGrid = document.getElementById('slotsGrid');
  const socksGrid = document.getElementById('socksGrid');
  const jocksGrid = document.getElementById('jocksGrid');
  const socksSection = document.getElementById('socksSection');
  const jocksSection = document.getElementById('jocksSection');
  const goToBasket = document.getElementById('goToBasket');
  const instruction = document.getElementById('bundleInstruction');

  // ---- No boks selected ----
  if (!boksHandle || !allBoks[boksHandle]) {
    layout.style.display = 'none';
    noBoksMsg.style.display = 'block';
    noBoksMsg.style.textAlign = 'center';
    noBoksMsg.style.padding = '80px 20px';
    return;
  }

  // ---- Config ----
  const boks = allBoks[boksHandle];
  const config = {
    socksRequired: boks.socksCount,
    jocksRequired: boks.jocksCount,
    totalSlots: boks.socksCount + boks.jocksCount,
  };

  // ---- Set box info ----
  document.getElementById('boksImage').src = boks.image;
  document.getElementById('boksImage').alt = boks.title;
  document.getElementById('boksName').textContent = boks.title;
  document.getElementById('boksPrice').textContent = boks.price;

  // ---- State ----
  const state = {
    slots: new Array(config.totalSlots).fill(null),
    socksAdded: 0,
    jocksAdded: 0,
    activeTab: 'socks',
  };

  // ---- Render slot grid ----
  function renderSlots() {
    slotsGrid.innerHTML = '';

    // Build interleaved order: distribute socks evenly around jocks
    // e.g. 2S+1J -> [sock, jock, sock], 4S+2J -> [sock, sock, jock, sock, sock, jock]
    var renderOrder = [];
    var s = config.socksRequired;
    var j = config.jocksRequired;

    if (j === 0) {
      // Socks only
      for (let i = 0; i < s; i++) renderOrder.push({ type: 'sock', slot: i });
    } else if (s === 0) {
      // Jocks only
      for (let i = 0; i < j; i++) renderOrder.push({ type: 'jock', slot: i });
    } else {
      // Interleave: spread socks evenly between jocks
      var socksPerGroup = Math.ceil(s / j);
      var sockIdx = 0;
      var jockIdx = 0;
      for (let g = 0; g < j; g++) {
        // Add socks before this jock
        var socksInGroup = Math.min(socksPerGroup, s - sockIdx);
        for (let si = 0; si < socksInGroup; si++) {
          renderOrder.push({ type: 'sock', slot: sockIdx++ });
        }
        // Add the jock
        renderOrder.push({ type: 'jock', slot: config.socksRequired + jockIdx++ });
      }
      // Any remaining socks
      while (sockIdx < s) {
        renderOrder.push({ type: 'sock', slot: sockIdx++ });
      }
    }

    // Render in interleaved order
    for (const item of renderOrder) {
      const isSock = item.type === 'sock';
      const slot = document.createElement('div');
      slot.className = 'bundle-slot' + (isSock ? '' : ' bundle-slot--jock');
      slot.dataset.slot = item.slot;
      slot.innerHTML = `
        <button class="bundle-slot__remove" data-slot="${item.slot}" aria-label="Remove item" style="display:none;">&times;</button>
        <div class="bundle-slot__placeholder">
          <button type="button" class="bundle-slot__add-btn ${isSock ? 'bundle-slot__add-btn--sock' : 'bundle-slot__add-btn--jock'}" data-scroll-to="${isSock ? 'socks' : 'jocks'}">
            Add ${isSock ? 'Sok' : 'Jok'}
          </button>
        </div>
        <div class="bundle-slot__filled" style="display:none;">
          <img src="" alt="" class="bundle-slot__item-image">
        </div>
      `;
      slotsGrid.appendChild(slot);
    }

    // Attach remove handlers
    slotsGrid.querySelectorAll('.bundle-slot__remove').forEach(btn => {
      btn.addEventListener('click', () => removeFromSlot(parseInt(btn.dataset.slot, 10)));
    });

    // Attach scroll handlers for Add Sock / Add Jock buttons
    slotsGrid.querySelectorAll('.bundle-slot__add-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.scrollTo === 'socks' ? socksSection : jocksSection;
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ---- Render sock products ----
  function renderSocks() {
    socksGrid.innerHTML = '';
    allSoks.forEach((sock, idx) => {
      const card = document.createElement('div');
      card.className = 'product-pick' + (sock.available ? '' : ' product-pick--unavailable');
      card.dataset.type = 'sock';
      card.dataset.productKey = 'sock-' + idx;
      card.innerHTML = `
        <button type="button" class="product-pick__image-link" data-show-details aria-label="View ${sock.title} details">
          <div class="product-pick__image">
            <img src="${sock.image}" alt="${sock.title}" loading="lazy">
          </div>
        </button>
        <h4 class="product-pick__title">
          <button type="button" class="product-pick__title-btn" data-show-details>${sock.title}</button>
        </h4>
        <p class="product-pick__size">Size 6-11</p>
        <button class="btn btn--primary btn--small product-pick__add" data-variant-id="${sock.variantId}" data-title="${sock.title}" data-image="${sock.image}" ${sock.available ? '' : 'disabled'}>
          ${sock.available ? 'ADD TO BOX' : 'OUT OF STOCK'}
        </button>
      `;
      socksGrid.appendChild(card);
    });
  }

  // ---- Render jock products ----
  function renderJocks() {
    jocksGrid.innerHTML = '';
    allJoks.forEach((jock, idx) => {
      const card = document.createElement('div');
      card.className = 'product-pick' + (jock.available ? '' : ' product-pick--unavailable');
      card.dataset.type = 'jock';
      card.dataset.productKey = 'jock-' + idx;

      let variantOptions = '<option value="">Choose Size</option>';
      jock.variants.forEach(v => {
        const label = v.available ? v.title : v.title + ' (sold out)';
        const disabled = v.available ? '' : 'disabled';
        variantOptions += `<option value="${v.id}" ${disabled}>${label}</option>`;
      });

      card.innerHTML = `
        <button type="button" class="product-pick__image-link" data-show-details aria-label="View ${jock.title} details">
          <div class="product-pick__image">
            <img src="${jock.image}" alt="${jock.title}" loading="lazy">
          </div>
        </button>
        <h4 class="product-pick__title">
          <button type="button" class="product-pick__title-btn" data-show-details>${jock.title}</button>
        </h4>
        <div class="product-pick__size-select">
          <select class="product-pick__size-dropdown" aria-label="Choose size" ${jock.available ? '' : 'disabled'}>
            ${variantOptions}
          </select>
        </div>
        <button class="btn btn--primary btn--small product-pick__add" data-title="${jock.title}" data-image="${jock.image}" ${jock.available ? '' : 'disabled'}>
          ${jock.available ? 'ADD' : 'OUT OF STOCK'}
        </button>
      `;
      jocksGrid.appendChild(card);
    });
  }

  // ---- Product detail modal ----
  const productModal = document.getElementById('productModal');
  const modalTitle = document.getElementById('modalTitle');
  const modalDescription = document.getElementById('modalDescription');
  const modalMainImage = document.getElementById('modalMainImage');
  const modalThumbnails = document.getElementById('modalThumbnails');

  function openProductModal(product) {
    modalTitle.textContent = product.title;
    modalDescription.innerHTML = product.description || '';
    const images = (product.images && product.images.length) ? product.images : [product.image];
    modalMainImage.src = images[0];
    modalMainImage.alt = product.title;
    modalThumbnails.innerHTML = '';
    if (images.length > 1) {
      images.forEach(src => {
        const thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'product-modal__thumb';
        thumb.innerHTML = `<img src="${src}" alt="">`;
        thumb.addEventListener('click', () => { modalMainImage.src = src; });
        modalThumbnails.appendChild(thumb);
      });
    }
    productModal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeProductModal() {
    productModal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  // Click on image or title -> open modal
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-show-details]');
    if (trigger) {
      const card = trigger.closest('.product-pick');
      if (!card) return;
      const key = card.dataset.productKey;
      const [type, idxStr] = key.split('-');
      const idx = parseInt(idxStr, 10);
      const product = type === 'sock' ? allSoks[idx] : allJoks[idx];
      if (product) openProductModal(product);
      return;
    }
    if (e.target.closest('[data-modal-close]')) {
      closeProductModal();
    }
  });

  // ESC key closes modal
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !productModal.hasAttribute('hidden')) {
      closeProductModal();
    }
  });

  // ---- Show/hide product sections based on what this BOKS needs ----
  if (config.socksRequired === 0) socksSection.style.display = 'none';
  if (config.jocksRequired === 0) jocksSection.style.display = 'none';

  // ---- Add item to slot ----
  function addToSlot(type, variantId, title, imageUrl, sku) {
    if (type === 'sock' && state.socksAdded >= config.socksRequired) {
      showMessage('All ' + config.socksRequired + ' sok slot(s) are filled!');
      return false;
    }
    if (type === 'jock' && state.jocksAdded >= config.jocksRequired) {
      showMessage('All ' + config.jocksRequired + ' jok slot(s) are filled!');
      return false;
    }

    let slotIndex = -1;
    if (type === 'sock') {
      for (let i = 0; i < config.socksRequired; i++) {
        if (!state.slots[i]) { slotIndex = i; break; }
      }
    } else {
      for (let i = config.socksRequired; i < config.totalSlots; i++) {
        if (!state.slots[i]) { slotIndex = i; break; }
      }
    }
    if (slotIndex === -1) return false;

    state.slots[slotIndex] = { type, variantId, title, imageUrl, sku };
    if (type === 'sock') state.socksAdded++;
    if (type === 'jock') state.jocksAdded++;

    const slotEl = slotsGrid.querySelector('[data-slot="' + slotIndex + '"]');
    slotEl.querySelector('.bundle-slot__placeholder').style.display = 'none';
    slotEl.querySelector('.bundle-slot__filled').style.display = 'block';
    slotEl.querySelector('.bundle-slot__remove').style.display = 'block';
    const img = slotEl.querySelector('.bundle-slot__item-image');
    img.src = imageUrl;
    img.alt = title;
    slotEl.classList.add('is-filled');

    updateUI();
    return true;
  }

  // ---- Remove item from slot ----
  function removeFromSlot(slotIndex) {
    const item = state.slots[slotIndex];
    if (!item) return;

    if (item.type === 'sock') state.socksAdded--;
    if (item.type === 'jock') state.jocksAdded--;
    state.slots[slotIndex] = null;

    const slotEl = slotsGrid.querySelector('[data-slot="' + slotIndex + '"]');
    slotEl.querySelector('.bundle-slot__placeholder').style.display = '';
    slotEl.querySelector('.bundle-slot__filled').style.display = 'none';
    slotEl.querySelector('.bundle-slot__remove').style.display = 'none';
    slotEl.classList.remove('is-filled');

    updateUI();
  }

  // ---- Update UI state ----
  function updateUI() {
    const totalFilled = state.socksAdded + state.jocksAdded;
    const remaining = config.totalSlots - totalFilled;

    // Instruction & basket button
    if (remaining === 0) {
      instruction.textContent = 'Your box is complete!';
      instruction.style.color = '#2e7d32';
      instruction.style.fontWeight = '700';
      goToBasket.style.display = 'inline-block';
      socksGrid.querySelectorAll('.product-pick__add').forEach(b => b.disabled = true);
      jocksGrid.querySelectorAll('.product-pick__add').forEach(b => b.disabled = true);
    } else {
      instruction.textContent = remaining + ' more item' + (remaining > 1 ? 's' : '') + ' to choose';
      instruction.style.color = '';
      instruction.style.fontWeight = '';
      goToBasket.style.display = 'none';

      // Enable/disable add buttons per category, but keep unavailable products disabled
      socksGrid.querySelectorAll('.product-pick__add').forEach(b => {
        const card = b.closest('.product-pick');
        const isUnavailable = card && card.classList.contains('product-pick--unavailable');
        b.disabled = isUnavailable || state.socksAdded >= config.socksRequired;
      });
      jocksGrid.querySelectorAll('.product-pick__add').forEach(b => {
        const card = b.closest('.product-pick');
        const isUnavailable = card && card.classList.contains('product-pick--unavailable');
        b.disabled = isUnavailable || state.jocksAdded >= config.jocksRequired;
      });
    }
  }

  function showMessage(msg) {
    instruction.textContent = msg;
    instruction.style.color = '#c62828';
    setTimeout(() => updateUI(), 2000);
  }

  // ---- Sock add handler ----
  socksGrid.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-pick__add');
    if (!btn || btn.disabled) return;
    const card = btn.closest('.product-pick');
    const idx = parseInt(card.dataset.productKey.split('-')[1], 10);
    const sock = allSoks[idx];
    addToSlot('sock', btn.dataset.variantId, btn.dataset.title, btn.dataset.image, sock.sku);
  });

  // ---- Jock add handler ----
  jocksGrid.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-pick__add');
    if (!btn || btn.disabled) return;

    const card = btn.closest('.product-pick');
    const sizeSelect = card.querySelector('.product-pick__size-dropdown');

    if (!sizeSelect.value) {
      sizeSelect.focus();
      sizeSelect.style.borderColor = '#c62828';
      setTimeout(() => { sizeSelect.style.borderColor = ''; }, 2000);
      showMessage('Please choose a size first');
      return;
    }

    const variantId = sizeSelect.value;
    const sizeName = sizeSelect.options[sizeSelect.selectedIndex].text;
    const fullTitle = btn.dataset.title + ' - ' + sizeName;

    const idx = parseInt(card.dataset.productKey.split('-')[1], 10);
    const jock = allJoks[idx];
    const variant = jock.variants.find(v => String(v.id) === String(variantId));

    addToSlot('jock', variantId, fullTitle, btn.dataset.image, variant ? variant.sku : null);
  });

  // ---- Go to basket ----
  goToBasket.addEventListener('click', async () => {
    goToBasket.disabled = true;
    goToBasket.textContent = 'ADDING...';

    try {
      const bundleId = Date.now().toString();

      // Build a properties object listing each chosen sock/jock under
      // a labelled key. Visible (non-underscore) keys appear on the
      // checkout under the bundle line item; underscore-prefixed keys
      // are hidden from customers but available for Shopify Flow.
      const bundleProps = {
        '_bundle': 'true',
        '_bundle_id': bundleId,
      };
      const componentVariantIds = [];
      const componentSkus = [];
      const componentQuantities = [];
      let sockNum = 0;
      let jockNum = 0;
      state.slots.forEach(slot => {
        if (!slot) return;
        let label;
        if (slot.type === 'sock') {
          sockNum++;
          label = config.socksRequired > 1 ? 'Sok ' + sockNum : 'Sok';
        } else {
          jockNum++;
          label = config.jocksRequired > 1 ? 'Jok ' + jockNum : 'Jok';
        }
        bundleProps[label] = slot.title;
        componentVariantIds.push(slot.variantId ? String(slot.variantId) : '');
        componentSkus.push(slot.sku ? String(slot.sku) : '');
        componentQuantities.push('1');
      });
      // Parallel comma-separated arrays describing each component slot.
      // OrderPro reads _bundle_skus / _bundle_quantities to know what to pick.
      // The Worker resolves variant IDs -> inventory items at order time.
      bundleProps['_bundle_variant_ids'] = componentVariantIds.join(',');
      bundleProps['_bundle_skus'] = componentSkus.join(',');
      bundleProps['_bundle_quantities'] = componentQuantities.join(',');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: boks.variantId,
            quantity: 1,
            properties: bundleProps,
          }],
        }),
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      // Redirect back to gift boxes collection
      window.location.href = '/collections/gift-boxes';
    } catch (err) {
      console.error('Bundle error:', err);
      goToBasket.disabled = false;
      goToBasket.textContent = 'ADD TO BASKET';
      showMessage('Something went wrong. Please try again.');
    }
  });

  // ---- Init ----
  renderSlots();
  renderSocks();
  renderJocks();
  updateUI();

})();
